/**
 * Firebase Configuration & Initialization
 *
 * This file sets up Firebase for the CTE CONNECT platform chat system.
 * Add your Firebase credentials to your .env file with VITE_ prefix.
 */

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getDatabase, Database } from 'firebase/database';
import { GoogleAuthProvider, signInWithPopup, UserCredential } from 'firebase/auth';

// Your Firebase project configuration from Firebase Console
const firebaseConfig = {
  projectId: 'studio-9483986446-a3660',
  appId: '1:860770499182:web:c87bd44d7c5702155f047f',
  apiKey: 'AIzaSyBbKIuMOkNXXd6VDXAzHx2l2GjFj0bwvQ4',
  authDomain: 'studio-9483986446-a3660.firebaseapp.com',
  storageBucket: 'studio-9483986446-a3660.appspot.com',
  messagingSenderId: '860770499182',
  measurementId: '',
  databaseURL: `https://studio-9483986446-a3660-default-rtdb.firebaseio.com`,
};

// Initialize Firebase (only if config is provided)
let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let db: Firestore | undefined;
let realtimeDb: Database | undefined;
let storage: FirebaseStorage | undefined;

try {
  // Only initialize if API key is provided
  if (firebaseConfig.apiKey) {
    app = initializeApp(firebaseConfig);

    // Initialize Authentication
    auth = getAuth(app);

    // Set persistence to LOCAL (so users stay logged in)
    setPersistence(auth, browserLocalPersistence).catch((error) => {
      console.warn('Auth persistence error:', error);
    });

    // Initialize Firestore Database
    db = getFirestore(app);

    // Initialize Realtime Database (for real-time chat)
    realtimeDb = getDatabase(app);

    // Initialize Storage (for file attachments)
    storage = getStorage(app);

    console.log('Firebase initialized successfully');
  } else {
    console.warn('Firebase not configured - add credentials to .env file');
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

// Export Firebase services
export { auth, db, realtimeDb, storage };
export default app;

/**
 * To use Firebase, add these to your .env file:
 *
 * VITE_FIREBASE_API_KEY=xxxxx
 * VITE_FIREBASE_AUTH_DOMAIN=xxxxx.firebaseapp.com
 * VITE_FIREBASE_PROJECT_ID=xxxxx
 * VITE_FIREBASE_STORAGE_BUCKET=xxxxx.appspot.com
 * VITE_FIREBASE_MESSAGING_SENDER_ID=xxxxx
 * VITE_FIREBASE_APP_ID=xxxxx
 * VITE_FIREBASE_MEASUREMENT_ID=xxxxx
 * VITE_FIREBASE_DATABASE_URL=https://xxxxx.firebaseio.com
 */

// Google Auth Provider instance
export const googleProvider = new GoogleAuthProvider();

/**
 * Sign in with Google popup
 * Usage: import { signInWithGoogle } from './firebase-config';
 *        signInWithGoogle().then(...)
 */
export async function signInWithGoogle(): Promise<UserCredential | undefined> {
  if (!auth) throw new Error('Firebase Auth not initialized');
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result;
  } catch (error) {
    console.error('Google sign-in error:', error);
    throw error;
  }
}
